;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  angular.module('app.shared-report', []).config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('shared-report', {
      url: '/shared-report/:surveyId?token&t',
      templateUrl: 'shared-report.html',
      controller: 'SharedReportController',
      controllerAs: '$ctrl',
      title: 'Shared Report',
      public: true,
    })
  }
})()
